<template>
  <div>
    <div v-if="infos.length === 0" class="h5 mt-1">
      Bisher sind keine Informationen vorhanden.
    </div>
    <div v-else>
      <div v-for="(info,idx) in infos" :key="idx" class="mb-3">
        <span class="font-weight-bold">{{info.sBezeichnung }}</span>
        <span class="cut-text">{{info.sText}}</span>
      </div>
    </div>
  </div>
</template>

<script>

  import TaskService from '../services/TaskService'

  export default {
    name: 'DashboardInfos',
    async mounted () {
      await this.init()
    },
    data () {
      return {
        infos: [],
        firmung: null
      }
    },
    methods: {
      async init () {
        var tmp = await TaskService.getMyDahsbordInfos()
        this.infos = tmp.data
      }
    },
    computed: {
      getLocation () {
        return this.$store.getters.getLocation
      }
    },
    watch: {
      'getLocation' () {
        this.init()
      }
    }
  }
</script>

<style scoped>
  .cut-text {
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 1.5rem;
    max-height: 4.5rem;
  }
</style>
